import {useCallback, useEffect, useState} from "react";
import {getOrder} from "../api/eventGroupApiClient";

export const useOrder = (orderId, reloadTrigger) => {
    const [order, setOrder] = useState(null);

    const fetchOrder = useCallback(async () => {
        try {
            const data = await getOrder(orderId);
            setOrder(data);
        }
        catch (error) {
            console.log(error);
        }
    }, [orderId]);

    useEffect(() => {
        fetchOrder();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchOrder, reloadTrigger]);

    return {order : order};
};